import { RemediationsWebComponent } from './component/RemediationsWebComponent';
import { WEB_COMPONENT_WIDGET_REMEDIATION_ACTIONS } from '../webcomponents.constants';

export { RemediationsWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_REMEDIATION_ACTIONS, RemediationsWebComponent);
